import { Flex, font } from '@lemonade-hq/cdk';
import { useI18nContext } from '@lemonade-hq/nuiza';
import { COLORS } from '@lemonade-hq/tokens';
import parse from 'html-react-parser';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';

const TweetCard = styled(Flex)`
  background: ${COLORS.white};
  height: 195px;
  width: 338px;
  box-shadow:
    0 1px 8px 0 rgba(0, 0, 0, 0.06),
    0 31px 30px -18px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 20px;
  box-sizing: content-box;
  p {
    ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })}
  }

  &.tweet-card {
    min-height: 0;
  }
`;

const TweetImage = styled(Image)`
  padding: 2px;
  position: relative;
  top: -5px;
  border-radius: 50%;
`;

const Name = styled.p`
  text-align: left;
  ${font('main', {
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
    fontWeight: 700,
  })};
`;

const Handle = styled.p`
  text-align: left;
  ${font('main', {
    fontSize: '1.4rem',
    lineHeight: '2.2rem',
    fontWeight: 700,
  })};
  color: ${COLORS.metal};
`;

const TweetText = styled.p`
  text-align: left;
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.4rem' })}

  .primary {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export interface TweetProps extends React.ComponentProps<'div'> {
  tweet: {
    img: string;
    handle: string;
    name: string;
    text?: string;
  };
}

const Tweet: React.FC<TweetProps> = ({ tweet, className = '' }) => {
  const { img, handle, name } = tweet;
  const { t } = useI18nContext();

  return (
    <TweetCard className={`tweet-card ${className}`} flexDirection="column" p={20} m={15}>
      <Flex flexDirection="row">
        <TweetImage src={img} alt={handle} height={50} width={50} />
        <Flex flexDirection="column" pl={10} flex="1">
          <Name>{name}</Name>
          <Handle>{handle}</Handle>
        </Flex>
      </Flex>
      <TweetText>{parse((tweet.text as string) ?? t(`hp.customer_reviews.tweets.${handle}`))}</TweetText>
    </TweetCard>
  );
};

export default Tweet;
